import React, { useEffect, useRef, useState } from 'react'
import {Facilities} from '../util/Facilities'


const FacilitySearchSelect = ({
 facilities = [], // default to empty array
  value,
  onChange,
  placeholder = 'Search facility, city, ZIP…'
}) => {
  const [query, setQuery] = useState('')
  const [open, setOpen] = useState(false)
  const wrapperRef = useRef(null)

  console.log(value)
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  // Show selected label when value is set (value is OBJECT now)
  useEffect(() => {
    if (!value) return
    setQuery(`${value.dropname} – ${value.dropdelcty}, ${value.dropdelst}`)
  }, [value])

  const filtered = facilities
    .filter(f => {
      const q = (query || '').toLowerCase()
      return (
        (f.dropname || '').toLowerCase().includes(q) ||
        (f.dropdelcty || '').toLowerCase().includes(q) ||
        (f.dropdelst || '').toLowerCase().includes(q) ||
        String(f.dropdelzpp || '').startsWith(query)
      )
    })
    .slice(0, 50)

  return (
    <div ref={wrapperRef} className="relative w-full">
      <input
        type="text"
        value={query}
        placeholder={placeholder}
        onChange={e => {
          setQuery(e.target.value)
          setOpen(true)
        }}
        onFocus={() => setOpen(true)}
        className="w-full h-9 px-3 border rounded-md text-sm"
        style={{position:'relative',border:"1px solid rgb(0,0,0,.3)",outline:'none',
fontSize:"calc(.9rem + .2vw)",
borderLeft:"10px solid rgba(122, 187, 67, .5)",
color:'black',
backgroundColor:'white',
}}
      />

      {open && (
        <div className="absolute z-30 mt-1 w-full max-h-64 overflow-auto bg-white border rounded-md shadow">
          {filtered.length === 0 && (
            <div className="px-3 py-2 text-xs text-gray-500">
              No matching facilities
            </div>
          )}

          {filtered.map(f => (
            <div
              key={f.fdbId}
              onClick={() => {
                onChange(f) // ✅ FULL OBJECT
                setQuery(`${f.dropname} – ${f.dropdelcty}, ${f.dropdelst}`)
                setOpen(false)
              }}
              className="px-3 py-2 cursor-pointer hover:bg-gray-100"
            >
              <div className="text-sm font-medium">
                {f.dropname}
              </div>
              <div className="text-xs text-gray-600">
                {f.dropdeladd} {f.dropdelcty}, {f.dropdelst} • {String(f.dropdelzpp || '').slice(0, 5)} 
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default FacilitySearchSelect
